module.exports = __webpack_public_path__ + "static/media/You & Me This Morning _ 5-12-2015.da8df0e9.png";